import { createSlice } from '@reduxjs/toolkit';

const notificationsDataSlice = createSlice({
  name: 'notificationsData',
  initialState: {
    data: []
  },
  reducers: {
    notificationsData(state, action) {
      state.data = action.payload.userNotifications;
    }
  }
});

export const notificationsDataActions =
  notificationsDataSlice.actions;

export default notificationsDataSlice;
